export enum ContactObject {
  SCIENTIFIC_CONTENT = "SCIENTIFIC_CONTENT",
  TECHNICAL_QUESTION = "TECHNICAL_QUESTION",
  SUBSCRIPTION = "SUBSCRIPTION",
  OTHER = "OTHER",
}
